'use strict';

import Actions from './actions';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import PropTypes from 'prop-types';

const propTypes = {
    error: PropTypes.string,
    loading : PropTypes.bool,
    success : PropTypes.bool,
    hasError : PropTypes.object,
    help : PropTypes.object,
    title: PropTypes.string,
    signinComplete: PropTypes.func
};

class SignInAfterRegister extends React.Component {
    constructor(props) {

        super(props);
    }

    autoLogin() {
        Actions.autoLogin(undefined, (err) => {

            if ( !err ){
                Actions.autoLoginClear();
                this.props.signinComplete();
            }
        });
    }

    render() {
        const alerts = [];

        if (this.props.error) {
            alerts.push(<div key="danger" className="alert alert-danger">
                {this.props.error}
            </div>);
        } else {
            alerts.push(<div key="success" className="alert alert-success text-center">
                <h4 className="sor-autosignin-success">Account creation successful!</h4>
            </div>);

        }

        return (
            <section className="sor">
                <h3 className="text-center sor-autosignin-title">{this.props.title}</h3>
                {alerts}
                <section className='sor-signin'>
                    <button
                        disabled={this.props.loading}
                        onClick={this.autoLogin.bind(this)}
                        className="btn btn-success btn-lg btn-block">
                        Continue
                        <Spinner space="left" show={this.props.loading} />
                    </button>
                </section>

            </section>
        );
    }
}

SignInAfterRegister.propTypes = propTypes;

export default SignInAfterRegister;
